const config = {
  chartId: "id",
  credits: { enabled: false },

  title: { text: null },
  chart: {
    renderTo: "container",
    type: "pie"
  },
  plotOptions: {
    pie: {
      // size: 200,
      size: "70%",
      dataLabels: {
        enabled: false,
        formatter: function() {
          return this.y;
        },

        distance: -50,
        color: "white",
        style: {
          textShadow: false
        }
      },
      showInLegend: true,
      tooltip: {
        pointFormat: "<b>{point.y}</b>"
      }
    }
  },
  legend: {
    itemMarginTop: 10,
    itemMarginBottom: 10,
    symbolHeight: 20,
    symbolWidth: 20,
    symbolRadius: 2,
    enabled: true,
    layout: "vertical",
    align: "right",
    width: 150,
    verticalAlign: "middle",
    useHTML: true,
    itemStyle: {
      lineHeight: "1em",
      color: "grey"
    },
    labelFormatter: function() {
      return this.name;
    }
  }
};

export default config;



// WEBPACK FOOTER //
// ./src/components/charts/chart-bar/ChartPieAdvConfig.js